import { CLOUD_PROVIDER_SERVICES } from './constants';

export const APIS = {
  /**
   * Accounts apis
   */
  ACCOUNT_DETAILS: (account: string) =>
    `/accounts/getAllAccounts?CloudProvider=${account}`,
  GET_ACCOUNT_LIST: () => '/accounts/getAllSubscription',
  VALIDATE_ACCOUNT_ARN: () => '/accounts/validateArnRole',
  ADD_MANUAL_AWS_ARN_ACCOUNT: () => '/accounts/createAccountWithArn',
  /**
   * Inventories apis
   */
  GET_BY_RESOURCE_NAMES: () => '/inventory/search',
  GET_RECENT_CREATED_RESOURCES: () => '/inventory/recentlycreated',
  GET_SERVICE_WISE_COST_LIST: () => '/costforecasting/service-wise-cost?',
  GET_SERVICE_DETAIL: () => '/costforecasting/resource-cost?',
  GET_SERVICE_FILTER: () => '/costforecasting/service-cost-category?',
  /**
   * Billing simplified or invoice apis
   */
  GET_BILLING_BY_TAGS: (params: any) =>
    `${
      params.provider === CLOUD_PROVIDER_SERVICES.AWS
        ? '/invoice/awsBillingCostByTags'
        : '/invoice/azureBillingCostByTags'
    }`,
  GET_RESOURCES_COST: (params: any) =>
    `${
      params.provider === CLOUD_PROVIDER_SERVICES.AWS
        ? '/invoice/awsResources/cost'
        : '/invoice/azureResources/cost'
    }`,

  /**
   * Security report apis
   */
  GET_INVENTORY_REPORT: (params: any) =>
    `${
      params.provider.CloudProvider === CLOUD_PROVIDER_SERVICES.AWS
        ? `aws/reports/${params.Id}`
        : `azure/reports/${params.Id}`
    }`,

  GET_SERVICES_REPORTS: (params: any) =>
    `costforecasting/servicesCost${
      params.cloudProvider === CLOUD_PROVIDER_SERVICES.AWS
        ? params.selectedAccounts
          ? `?selectedAccounts=${params.selectedAccounts}`
          : ''
        : params.AzureId
        ? `?AzureId=${params.AzureId}`
        : `?SubscriptionId=${params.SubscriptionId || 'all'}`
    }`,
  GET_RESOURCES_SERVICES_REPORTS: (params: any) =>
    `costforecasting/servicesResourseCost?ChartType=pieChart&ServiceType=${
      params.serviceType
    }&${
      params.CloudProvider === CLOUD_PROVIDER_SERVICES.AWS
        ? `subscriptionId=${params.SubscriptionId}`
        : params.AzureId
        ? `azureId=${params.AzureId}`
        : `subscriptionId=${params.SubscriptionId || 'all'}`
    }`,
  GET_SERVICE_WISE_COST: () => '/costforecasting/servicesCost?',
  GET_SERVICE_WISE_REPORT_CSV: () =>
    'costforecasting/billing-summary-download?',

  /**
   * User List apis
   */

  GET_COMPANY_LIST: () => '/users/companies',

  DELETE_USER: () => '/users/delete',

  /**
   * App Dashboard apis
   */

  GET_DASHBOARD_RIGHTSIZING: () => '/dashboard/rightsizing',
  GET_DASHBOARD_IDLE_RESOURCES: () => '/dashboard/idle',
  GET_DASHBOARD_SPEND_BY_SERVICE: () => '/dashboard/spendByService',
  GET_DASHBOARD_SPEND_FORECAST_RESOURCES: () => '/dashboard/spendForecast',
  GET_DASHBOARD_SPEND_AMOUNT: () => '/dashboard/sependAmount',
  GET_DASHBOARD_PER_CHANGE: () => '/dashboard/percentageChange',
  GET_DASHBOARD_Accounts: () => '/dashboard/getDashboardAccounts',
  GET_DASHBOARD_NOTIFICATION: () => '/notifications/getall',
  // GET_USERS_FEATURESS: () => '/features/create',
  GET_RDS_RIGHTSIZING_DATA: (accountId: string) =>
    `/rightsizing/resizeRDSInstance?accountId=${accountId}`,

  /**
   * Custom Notification apis
   */

  GET_SLACK_CREDS: () => '/customnotification/slack/get',
  SET_SLACK_CREDS: () => '/customnotification/slack/create',
  POST_CUSTOM_NOTIFICATION: () => '/customnotification/notification/update',
  COMPANY_NOTIFICATION: () => '/customnotification/companynotification/update',
  FETCH_ON_SLACK_CHANNELS_OF_SERVICE: () =>
    'customnotification/slacknotification/get',
  FETCH_SERVICE_NOTIFICATION_STATUS: () =>
    'customnotification/companynotification/get',
  UPDATE_SLACK_CREDS: () => 'customnotification/slack/update',
  SET_GCHAT_DATA: () => 'customnotification/gchat/create',
  GET_GCHAT_DATA: () => 'customnotification/gchat/get',
  UPDATE_GCHAT_DATA: () => 'customnotification/gchat/update',
  DELETE_GCHAT_DATA: () => 'customnotification/gchat/delete',

  /**
   * Cost Forecast apis
   */

  GET_RESOURCE_LIST: () => '/costforecasting/getResourseList',
  GET_RESOURCE_DETAIL: () => '/costforecasting/getResourseCost',
  SET_RESOURCE_COST: () => '/costforecasting/saveResourseCost',
  GET_HIGHEST_CONSUMED_RESOURCES: () => '/costforecasting/mostUsesResourse',
  GET_BILLING_SUMMARY: () => '/costforecasting/billing-summary?',
  GET_GRID_SUMMARY: () => '/costforecasting/billing-statistics?',

  //  Uptime Monitoring

  ADD_URL: () => '/monitoring/addUrl',
  GET_URLs: (pageNo: number, Type: string) =>
    `/monitoring/getCompanyUrls?page=${pageNo}&MonitoringType=${Type}`,
  DELETE_URL: () => '/monitoring/removeUrl',
  EDIT_URL: () => '/monitoring/editUrlDetails',
  TOGGLE_MONITORING: () => 'monitoring/toggleMonitoring',
  GET_MONITORING_DETAIL: () => 'monitoring/getMonitoringData',
  GET_QUICK_STATUS: () => 'monitoring/getAvgResponseData',
  GET_MONITORING_EMAILS: () => '/monitoring/getCompanyEmails',
  ADD_EMAIL: () => '/monitoring/addEmail',
  GET_NON_REGISTERED_EMAIL: () => '/monitoring/getCompanyNonRegesteredEmails',
  DELETE_NON_REGISTERED_EMAIL: () =>
    '/monitoring/deleteCompanyNonRegesteredEmails',
  GET_SSL_DAYS: () => '/customnotification/SSL/get',
  SET_SSL_DAYS: () => '/customnotification/SSL/create',
  DELETE_SSL_DAYS: () => '/customnotification/SSL/delete',
  UPLOAD_URL_CSV: () => '/monitoring/uploadUrlCsv',
  DOWNLOAD_URL_CSV: () => '/monitoring/downloadCsvFormat',
  DOWNLOAD_MONITORING_REPORT: () => '/monitoring/getMonitoringReport',
  EXPORT_DASHBOARD_MONITORING_REPORT: () =>
    '/monitoring/downloadURLMonitoringExcelSheet',
  GET_URL_NOTIFICATION_LOGS: () => '/monitoring/getNotificationLogs',
  /**
   * Url Monitoring apis
   */

  GET_URL_MONITORING: () => '/monitoring/getMonitoringDetail',
  ADD_URL_MAINTENANCE: () => '/monitoring/addMaintenanceMode',
  EDIT_URL_MAINTENANCE: () => '/monitoring/editMaintenanceMode',
  ADD_MAINTENANCE_SCHEDULE: () => '/monitoring/schedules',
  EDIT_MAINTENANCE_SCHEDULE: () => '/monitoring/schedules',
  GET_MAINTENANCE_SCHEDULE: () => '/monitoring/schedules',
  DELETE_MAINTENANCE_SCHEDULE: () => '/monitoring/schedules',
  GET_ENVIRONMENT_LABELS: () => '/monitoring/getLabels',

  // Real User Monitoring

  GET_RUM_DATA: () => '/rum/clients',
  ADD_RUM_SITE: () => '/rum/copyscript',
  GET_PLATFORM_BROSWER_DATA: () => '/rum/platforms-session-load',
  GET_COUNTRY_WISE_SESSION_DATA: () => '/rum/countryWiseSessions',
  GET_COUNTRY_WISE_VIEWS: () => '/rum/countryWiseViews',
  GET_SESSIONS_VIEW: () => '/rum/sessionview',
  DELETE_RUM_CLIENT: () => '/rum/deletesite',
  GET_SCRIPT: () => '/rum/getscript',
  GET_APDEX_DETAIL: () => '/rum/apdex',
  GET_PAGE_WISE_DETAIL: () => '/rum/PageWiseDetails',

  /**
   * Cost Analysis
   */

  GET_COST_USAGE: () => '/usageReport/get',
  GET_CATEGORY_LIST: () => '/usageReport/filter',
  DOWNLOAD_COST_REPORT: () => '/usageReport/cost-report-download',

  /**
   * Cost Analysis
   */

  GET_MULTI_ACCOUNT_DATA: () => '/multiAccounts/get-report',
  DOWNLOAD_MULTI_ACCOUNT_REPORT: () => '/multiAccounts/report-download',

  /**
   * Health Monitoring
   */

  GET_ALL_INSTANCE: () => '/systemHealth/allinstance',
  ADD_SERVER_HEALTH_PRIMARY_KEY_DATA: () =>
    '/systemHealth/server-health-url-primary-key',
  GET_SERVER_HEALTH_CREDS: () => '/systemHealth/get-server-health-creds',
  ADD_SERVER_HEALTH_CREDS: () => '/systemHealth/addSystemHealthCreds',
  GET_QUICK_CPU_MEMORY_DISK: () => '/systemHealth/quickCpuMemoryDisk',
  GET_BASIC_CPU_USAGE: () => '/systemHealth/cpubasic',
  GET_BASIC_MEMORY_USAGE: () => '/systemHealth/memorybasic',
  GET_BASIC_NETWORK_TRAFFIC_USAGE: () => '/systemHealth/network-traffic',
  GET_BASIC_DISK_SPACE_USAGE: () => '/systemHealth/disk-used',
  GET_CPU_MEMORY_NETWORK_DISK: () => '/systemHealth/cpu-memory-net-disk',
  GET_MEMORY_STACK: () => '/systemHealth/memory-stack',
  GET_DISK_SPACE_USED: () => '/systemHealth/disk-space-used',
  GET_DISK_IOPS: () => '/systemHealth/disk-iops',
  GET_IO_USAGE_READ_WRITE: () => 'systemHealth/io-usage-read-write',
  GET_IO_UTILIZATION: () => 'systemHealth/io-utilization',
  //Memory section
  GET_MEMORY_ACTIVE_INACTIVE: () => 'systemHealth/memory-active-inactive',
  GET_MEMORY_COMMITTED: () => 'systemHealth/memory-commmitted',
  GET_MEMORY_ACTIVE_INACTIVE_DETAIL: () =>
    'systemHealth/memory-active-inactive-detail',
  GET_MEMORY_WRITEBACK_DIRTY: () => 'systemHealth/memory-writeback-dirty',
  GET_MEMORY_SHARED_MAPPED: () => 'systemHealth/memory-shared-mapped',
  GET_MEMORY_SLAB: () => 'systemHealth/memory-slab',
  GET_MEMORY_VMALLOC: () => 'systemHealth/memory-vmalloc',
  GET_MEMORY_ANONYMOUS: () => 'systemHealth/memory-anonymous',
  GET_MEMORY_KERNEL_CPU: () => 'systemHealth/memory-kernel-cpu',
  GET_MEMORY_HUGE_PAGES_SIZE: () => 'systemHealth/memory-huge-pages-size',
  GET_MEMORY_DIRECT_MAP: () => 'systemHealth/memory-direct-map',
  GET_MEMORY_UNEVICTABLE_MLOCKED: () =>
    'systemHealth/memory-unevictable-mlocked',
  /////////////////////////////////////////////////////////////////////////////////

  /**
   * Billing apis
   */

  NEW_SUBSCRIPTION: () => '/stripe/subscribe',
  CHANGE_SUBSCRIPTION: () => '/stripe/changeSubscription',
  ADD_CARD: () => '/stripe/addCard',
  DELETE_CARD: () => '/stripe/removeCard',
  SET_AS_DEFAULT: () => '/stripe/setDefaultPaymentMethod',
  GET_CARD: () => '/stripe/customerCardDetails',
  GET_PLAN_DETAILS: () => '/stripe/allPlans',

  GET_PLAN_INFO: () => '/stripe/getAllPlans',
  GET_PLAN_BY_COMPANY: () => '/stripe/getCompanyPlans',
  ADD_PLAN: () => '/stripe/addPlan',
  DELETE_PLAN: () => '/stripe/deletePlan',
  DELETE_FEATURE: () => 'stripe/deletePlanDetails',
  EDIT_PLAN: () => '/stripe/updatePlanDetails',

  CANCEL_SUBSCRIPTION: () => '/stripe/cancelSubscriptionAtPeriodEnd',
  COMPANY_DETAILS: () => 'company/getCompany',
  RETRY_PAYMENT: () => '/stripe/payIncompleteSubscription',
  REQUEST_QUOTE: () => '/stripe/requestPlan',

  // uploaded document
  GET_UPLOADED_DOCUMENTS: () => '/users/alldocs',
  GET_UPLOADED_DOCUMENTS_STATIC: (token: string) =>
    `/users/viewDocx?token=${token}`,
  SHARE_DOC: () => '/users/sharedoc',

  // Admin Panel
  GET_ALL_ORGANISATION_DETAILS: () => '/company/allorganisation',
  GET_ALL_SUPER_ADMIN_ORGANISATION: () =>
    '/super-admin/company/allOrganisation',
  GET_ADMIN_ANALYSIS_DETAILS: () => '/super-admin/analytics/getAnalytics',
  GET_ADMIN_RECENT_ACTIVITIES: () =>
    '/super-admin/dashboard/getBillingRecentActivities',
  GET_ALL_ORG_COST: () => '/super-admin/costing/listCompaniesCost',
  GET_ORG_PLAN_DETAIL: (company: string) =>
    `/super-admin/company/getCompanyInfo?companyName=${company}`,
  GET_ORG_CLOUD_COSTS: () => '/super-admin/costing/listAccountCost',
  GET_TOP_ORG_SERVICE_WISE_COST: () => '/super-admin/costing/topCostlyServices',
  GET_ORGANISATION_USERS: (company: string) =>
    `/users/companyUsers?company=${company}`,
  GET_ACCOUNTS_DETAILS: (company: string) =>
    `/accounts/acccountlist?company=${company}`,
  UPDATE_USERS_DETAILS: () => '/users/updateUser',
  DELETE_USERS_DETAILS: () => '/users/deleteUser',
  UPDATE_ORGANISATON_STATUS: () => '/company/updateCompanyStatus',
  UPDATE_ORGANISATION_SYNC_JOB: () =>
    '/super-admin/company/updateCompanySyncJob',
  UPDATE_ALL_ORGANISATON_STATUS: () => '/company/updateAllCompaniesStatus',
  DELETE_ORGANISATON: () => '/company/deleteCompany',
  UPDATE_ACCOUNT_DETAILS: () => '/accounts/updateAccountStatus',
  DELETE_ACCOUNT_DETAILS: () => '/accounts/deleteAccountDetails',
  UPLOAD_DOCUMENTS: (companyName: string, friendlyName: string) =>
    `/users/upload?company=${companyName}&friendlyName=${friendlyName}`,
  UPLOAD_USERS_INFO: () => '/users/docusers',
  ADD_ORGANIZATIONS: () => '/company/addcompany',
  GET_ALL_USERS_FOR_SUPER_ADMIN: () => '/users/admin-dashboard/getAllUsers',
  GET_COMPANY_FEATURES: () => '/features/getAll',
  GET_ALL_FEATURES_LIST: () => '/features/list',
  GET_ACTIVE_SUB: () => '/stripe/getActiveSubscriptions',
  GET_ALL_BILLING_REQUEST: () => '/stripe/getAllRequest',
  SET_BILLING_REQUEST: () => '/stripe/createPrice',
  ADD_PLAN_FEATURES: () => '/stripe/addPlanFeatures',
  GET_ORG_BILLING_HISTORY: (companyName: string) =>
    `/subscription/allsubshistory?company=${companyName}`,
  GET_SYSTEM_HEALth_DATA: (accountId: string, company: string) =>
    `/accountHealth/health-data?account=${accountId}&company=${company}`,
  GET_ACTIVE_ACCOUNTS: (companyName: string) =>
    `/accounts/accountlist?company=${companyName}`,
  GET_JOB_FAILUR_DETAILS: (
    services: string,
    account: string,
    jobdate: string,
    cloud: string
  ) =>
    `/accounts/healthdetails?services=${services}&account=${account}&jobdate=${jobdate}&cloud=${cloud}`,

  /**
   * SubAdmin pannel
   */

  ADD_SUB_ADMIN_ACCOUNT: () => '/super-admin/subadmin/create',
  LIST_SUB_ADMIN_ACCOUNT: () => '/super-admin/subadmin/list',
  LIST_SUPER_ADMIN_FEATURES: () => '/features/superadmin-features',

  /**
   * Billing Console
   */

  GET_BILLING_CONSOLE: () => '/invoice/billing-console',
  GET_CSV_BILLING_CONSOLE: () => '/invoice/billing-console/download',

  GET_ACCOUNTWISE_BREAKUP: () => '/invoice/billing-console',
  DOWNLOAD_SERVICE_ACCOUNTWISE_REPORT: () =>
    '/invoice/billing-console/download',

  /**
   * Cost Breakup
   */

  GET_INSTANCE_COST: () => '/costBreakup/instance',
  GET_CLOUDWATCH_REPORT: () => '/costBreakup/cloudwatch',
  GET_STORAGE_REPORT: () => '/costBreakup/storage',
  GET_SECURITY_REPORT: () => '/costBreakup/security',
  GET_SERVERLESS_REPORT: () => '/costBreakup/serverless',
  GET_ANALTICS_REPORT: () => '/costBreakup/analytics',
  GET_MEDIA_SERVICES_REPORT: () => '/costBreakup/mediaservice',
  GET_CONTAINERS_COST: () => '/costBreakup/containers',
  GET_NETWORK_DELIVERY_REPORT: () => '/costBreakup/networking-content-delivery',
  DOWNLOAD_INSTANCE_COST_REPORT: () => '/costBreakup/instance-report-download',
  DOWNLOAD_STORAGE_COST_REPORT: () => '/costBreakup/storage-report-download',
  DOWNLOAD_SECURITY_REPORT: () => '/costBreakup/security-report-download',
  DOWNLOAD_SERVERLESS_COST_REPORT: () =>
    '/costBreakup/serverless-report-download',
  DOWNLOAD_CLOUDWATCH_COST_REPORT: () =>
    '/costBreakup/cloudwatch-report-download',
  DOWNLOAD_ANALYTICS_COST_REPORT: () =>
    '/costBreakup/analytics-report-download',
  DOWNLOAD_MEDIA_SERVICES_COST_REPORT: () =>
    '/costBreakup/media-services-report-download',
  DOWNLOAD_NETWORK_COST_REPORT: () => '/costBreakup/network-report-download',
  DOWNLOAD_CONTAINERS_COST_REPORT: () =>
    '/costBreakup/container-report-download',

  /**
   * Reservations Reports
   */

  GET_COVERAGE_REPORT: () => '/reservation/coverage',
  DOWNLOAD_COVERAGE_REPORT: () => '/reservation/coverage-download',
  GET_SUMMARY_REPORT: () => '/reservation/summary',
  DOWNLOAD_SUMMARY_REPORT: () => '/reservation/summary-download',

  // super admin billing apis
  DOWNLOAD_INVOICE: () => 'invoice/download',

  GOOGLE_AUTH_TOKEN: () => '/auth/google/token',
  OAUTH_STATUS: () => '/auth/status',
};
